import { render } from "./ClaimsOverview.vue?vue&type=template&id=099826f4&scoped=true&ts=true"
import script from "./ClaimsOverview.vue?vue&type=script&lang=ts"
export * from "./ClaimsOverview.vue?vue&type=script&lang=ts"

import "./ClaimsOverview.vue?vue&type=style&index=0&id=099826f4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099826f4"]])

export default __exports__